var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDescription(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_description"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon 24px"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Color",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33268 10.6663H10.666V11.9997H5.33268V10.6663ZM5.33268 7.99969H10.666V9.33303H5.33268V7.99969ZM9.33268 1.33301H3.99935C3.26602 1.33301 2.66602 1.93301 2.66602 2.66634V13.333C2.66602 14.0663 3.25935 14.6663 3.99268 14.6663H11.9993C12.7327 14.6663 13.3327 14.0663 13.3327 13.333V5.33301L9.33268 1.33301ZM11.9993 13.333H3.99935V2.66632H8.66602V5.99965H11.9993V13.333Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDescription);
export default __webpack_public_path__ + "static/media/ic_description.bad1c03d7aedf72d6c938ceaf32c5434.svg";
export { ForwardRef as ReactComponent };